'use client';

import { motion } from 'framer-motion';
import { ReactNode } from 'react';

interface MagneticButtonProps {
    children: ReactNode;
    className?: string;
    strength?: number; // Kept for prop compatibility but ignored for stabilization
}

/**
 * PremiumButtonWrapper - Formerly MagneticButton
 * Pivoted from aggressive physical translation to stable Material 3 executive motion.
 * Provides subtle scaling and elevation feedback without the "drunken" jitter.
 */
export default function MagneticButton({ children, className = "" }: MagneticButtonProps) {
    return (
        <motion.div
            whileHover={{
                scale: 1.02,
                transition: {
                    duration: 0.2,
                    ease: [0.2, 0, 0, 1] // M3 Emphasized
                }
            }}
            whileTap={{ scale: 0.98 }}
            className={`relative inline-block ${className}`}
        >
            {children}
        </motion.div>
    );
}
